<script>
  import { urlServeur, tabCouleurAugmentation } from "./conf.js";
  import Spinner from "./ToolsSpinner.svelte";
  import PrimeLastYear from "../components/SalairePrimeOneYear.svelte";

  let promise;
  let les_annees = {};

  const fetchAgmentation = async () => {
    const response = await fetch(urlServeur + "/api_employe/historique_prime"); // possibilite d' ajouter le nre b d'anned
    if (response.ok) {
      const res = await response.json();
      les_annees = res.payload.liste_tab_annee;
      //console.log(les_annees);
      //console.log(res.payload.liste_prime);
      return res.payload.liste_prime;
    }
  };

  const couleurAug = (couleur) => {
    if (couleur > 3) {
      couleur = 4;
    }
    return tabCouleurAugmentation[couleur];
  };

  promise = fetchAgmentation();
</script>

{#await promise}
  <Spinner />
{:then elements}
  <div class="row">
    <div class="col-sm-12">
      <h6>Primes des 5 dernières années</h6>
      <table class="table table-responsive table-sm">
        <thead>
          <tr class="thinfo">
            <td>nom</td>
            {#each Object.entries(les_annees) as [keyAnnee]}
              <td>{keyAnnee}</td>
            {/each}
          </tr>
        </thead>
        <tbody>
          {#each Object.entries(elements) as [keyNom, keyValeurTabPrime]}
            <tr>
              <td class="col-md-3"> {keyNom}</td>
              {#each Object.entries(keyValeurTabPrime) as [keyValeurTabAnnee, valuePrime]}
                <td class={valuePrime.prime == 0 ? "vide" : "info"}
                  >{valuePrime.prime == 0
                    ? "-"
                    : new Intl.NumberFormat("fr-FR").format(
                        valuePrime.prime
                      )}</td
                >
              {/each}
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  </div>
  <div class="row">
    <PrimeLastYear />
  </div>
{/await}

<style>
  .table {
    font-size: 0.65em;
  }
  .thinfo {
    background-color: dodgerblue;
  }
  .vide {
    background-color: rgb(172, 176, 176);
  }
</style>
